import SupportLanguage from './SupportLanguage';
import CompositedAssetProvider from '../CompositeBundleAssetProvider';

export default class I18nAssetProvider extends CompositedAssetProvider<SupportLanguage> {}
